import React from "react";

// A physical tabletop and legs, using the same outline weight as the UI icons.
export default function DiningTableIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
      stroke="currentColor" strokeWidth="1.75" strokeLinecap="round"
      strokeLinejoin="round" aria-hidden="true" focusable="false" {...props}>
      <path d="M5 5h14l3 7H2l3-7Z" />
      <path d="M4 12v8m16-8v8M8 12v4m8-4v4" />
    </svg>
  );
}
